import { render, staticRenderFns } from "./StudentFeedback.vue?vue&type=template&id=94b42218&scoped=true"
import script from "./StudentFeedback.vue?vue&type=script&lang=js"
export * from "./StudentFeedback.vue?vue&type=script&lang=js"
import style0 from "./StudentFeedback.vue?vue&type=style&index=0&id=94b42218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b42218",
  null
  
)

export default component.exports